"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GnoWallet = void 0;
var tm2_js_client_1 = require("@gnolang/tm2-js-client");
var utility_1 = require("./utility");
var long_1 = __importDefault(require("long"));
var proto_1 = require("../proto");
var endpoints_1 = require("./endpoints");
/**
 * GnoWallet is an extension of the TM2 wallet with
 * specific functionality for Gno chains
 */
var GnoWallet = /** @class */ (function (_super) {
    __extends(GnoWallet, _super);
    function GnoWallet() {
        var _this = _super.call(this) || this;
        /**
         * Initiates a native currency transfer transaction between accounts
         * @param {string} to the bech32 address of the receiver
         * @param {Map<string, number>} funds the denomination -> value map for funds
         * @param {TransactionEndpoint} endpoint the transaction broadcast type (sync / commit)
         * @param {TxFee} [fee] the custom transaction fee, if any
         */
        _this.transferFunds = function (to, funds, endpoint, fee) { return __awaiter(_this, void 0, void 0, function () {
            var amount, sender, txFee, sendMsg, tx, signedTx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        amount = (0, utility_1.fundsToCoins)(funds);
                        return [4 /*yield*/, this.getAddress()];
                    case 1:
                        sender = _b.sent();
                        txFee = fee
                            ? fee
                            : {
                                gasWanted: new long_1.default(60000),
                                gasFee: utility_1.defaultTxFee,
                            };
                        sendMsg = {
                            from_address: sender,
                            to_address: to,
                            amount: amount,
                        };
                        tx = {
                            messages: [
                                {
                                    typeUrl: endpoints_1.MsgEndpoint.MSG_SEND,
                                    value: proto_1.MsgSend.encode(sendMsg).finish(),
                                },
                            ],
                            fee: txFee,
                            memo: '',
                            signatures: [], // No signature yet
                        };
                        return [4 /*yield*/, this.signTransaction(tx, utility_1.decodeTxMessages)];
                    case 2:
                        signedTx = _b.sent();
                        // Send the transaction
                        return [2 /*return*/, this.sendTransaction(signedTx, endpoint)];
                }
            });
        }); };
        /**
         * Invokes the specified method on a GNO contract
         * @param {string} path the gno package / realm path
         * @param {string} method the method name
         * @param {string[]} args the method arguments, if any
         * @param {TransactionEndpoint} endpoint the transaction broadcast type (sync / commit)
         * @param {Map<string, number>} [funds] the denomination -> value map for funds, if any
         * @param {TxFee} [fee] the custom transaction fee, if any
         */
        _this.callMethod = function (path, method, args, endpoint, funds, fee) { return __awaiter(_this, void 0, void 0, function () {
            var amount, caller, txFee, callMsg, tx, signedTx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        amount = (0, utility_1.fundsToCoins)(funds);
                        return [4 /*yield*/, this.getAddress()];
                    case 1:
                        caller = _b.sent();
                        txFee = fee
                            ? fee
                            : {
                                gasWanted: new long_1.default(60000),
                                gasFee: utility_1.defaultTxFee,
                            };
                        callMsg = {
                            caller: caller,
                            send: amount,
                            pkg_path: path,
                            func: method,
                            args: args ? (args.length === 0 ? null : args) : null,
                        };
                        tx = {
                            messages: [
                                {
                                    typeUrl: endpoints_1.MsgEndpoint.MSG_CALL,
                                    value: proto_1.MsgCall.encode(callMsg).finish(),
                                },
                            ],
                            fee: txFee,
                            memo: '',
                            signatures: [], // No signature yet
                        };
                        return [4 /*yield*/, this.signTransaction(tx, utility_1.decodeTxMessages)];
                    case 2:
                        signedTx = _b.sent();
                        // Send the transaction
                        return [2 /*return*/, this.sendTransaction(signedTx, endpoint)];
                }
            });
        }); };
        /**
         * Deploys the specified package / realm
         * @param {MemPackage} gnoPackage the package / realm to be deployed
         * @param {TransactionEndpoint} endpoint the transaction broadcast type (sync / commit)
         * @param {Map<string, number>} [funds] the denomination -> value map for funds, if any
         * @param {TxFee} [fee] the custom transaction fee, if any
         */
        _this.deployPackage = function (gnoPackage, endpoint, funds, fee) { return __awaiter(_this, void 0, void 0, function () {
            var amount, caller, txFee, addPkgMsg, tx, signedTx;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        amount = (0, utility_1.fundsToCoins)(funds);
                        return [4 /*yield*/, this.getAddress()];
                    case 1:
                        caller = _b.sent();
                        txFee = fee
                            ? fee
                            : {
                                gasWanted: new long_1.default(60000),
                                gasFee: utility_1.defaultTxFee,
                            };
                        addPkgMsg = {
                            creator: caller,
                            package: gnoPackage,
                            deposit: amount,
                        };
                        tx = {
                            messages: [
                                {
                                    typeUrl: endpoints_1.MsgEndpoint.MSG_ADD_PKG,
                                    value: proto_1.MsgAddPackage.encode(addPkgMsg).finish(),
                                },
                            ],
                            fee: txFee,
                            memo: '',
                            signatures: [], // No signature yet
                        };
                        return [4 /*yield*/, this.signTransaction(tx, utility_1.decodeTxMessages)];
                    case 2:
                        signedTx = _b.sent();
                        // Send the transaction
                        return [2 /*return*/, this.sendTransaction(signedTx, endpoint)];
                }
            });
        }); };
        return _this;
    }
    var _a;
    _a = GnoWallet;
    /**
     * Generates a private key-based wallet, using a random seed
     * @param {AccountWalletOption} options the account options
     */
    GnoWallet.createRandom = function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var wallet, gnoWallet;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, tm2_js_client_1.Wallet.createRandom(options)];
                case 1:
                    wallet = _b.sent();
                    gnoWallet = new _a();
                    gnoWallet.signer = wallet.getSigner();
                    return [2 /*return*/, gnoWallet];
            }
        });
    }); };
    /**
     * Generates a bip39 mnemonic-based wallet
     * @param {string} mnemonic the bip39 mnemonic
     * @param {CreateWalletOptions} options the wallet generation options
     */
    GnoWallet.fromMnemonic = function (mnemonic, options) { return __awaiter(void 0, void 0, void 0, function () {
        var wallet, gnoWallet;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, tm2_js_client_1.Wallet.fromMnemonic(mnemonic, options)];
                case 1:
                    wallet = _b.sent();
                    gnoWallet = new _a();
                    gnoWallet.signer = wallet.getSigner();
                    return [2 /*return*/, gnoWallet];
            }
        });
    }); };
    /**
     * Generates a private key-based wallet
     * @param {string} privateKey the private key
     * @param {AccountWalletOption} options the account options
     */
    GnoWallet.fromPrivateKey = function (privateKey, options) { return __awaiter(void 0, void 0, void 0, function () {
        var wallet, gnoWallet;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, tm2_js_client_1.Wallet.fromPrivateKey(privateKey, options)];
                case 1:
                    wallet = _b.sent();
                    gnoWallet = new _a();
                    gnoWallet.signer = wallet.getSigner();
                    return [2 /*return*/, gnoWallet];
            }
        });
    }); };
    /**
     * Creates a Ledger-based wallet
     * @param {LedgerConnector} connector the Ledger device connector
     * @param {CreateWalletOptions} options the wallet generation options
     */
    GnoWallet.fromLedger = function (connector, options) {
        var wallet = tm2_js_client_1.Wallet.fromLedger(connector, options);
        var gnoWallet = new _a();
        gnoWallet.signer = wallet.getSigner();
        return gnoWallet;
    };
    return GnoWallet;
}(tm2_js_client_1.Wallet));
exports.GnoWallet = GnoWallet;
